// We need to import the shim because React 17 does not support the `useSyncExternalStore` API.
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';
export function useSelector(store, selector, a1, a2, a3) {
  const selectorWithArgs = state => selector(state, a1, a2, a3);
  return useSyncExternalStoreWithSelector(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs);
}